<template>
  <div>
    <h4>{{ $t('dashboard.widgets.ritual_tasks.title') }}</h4>
    <v-row class="ma-0 fill-height align-center">
      <v-col>
        <v-row class="ma-0 align-center">
          <h1>{{ created }}</h1>
          <span class="ml-2">{{ $t('dashboard.widgets.ritual_tasks.created') }}</span>
        </v-row>
      </v-col>
      <v-col>
        <v-row class="ma-0 align-center">
          <h1>{{ completed }}</h1>
          <span class="ml-2">{{ $t('dashboard.widgets.ritual_tasks.completed') }}</span>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export interface RitualTasksData {
  ritual_tasks: Array<{ done: string; total: string }>;
}

export default Vue.extend({
  name: 'm-ritual-tasks-widget',
  props: {
    value: { type: Object as PropType<RitualTasksData> },
  },
  data: () => ({
    created: 0,
    completed: 0,
  }),
  async mounted() {
    const values = this.value?.ritual_tasks?.[0];
    this.completed = Number(values?.done ?? 0);
    this.created = Number(values?.total ?? 0);
  },
});
</script>
